import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useShops } from '../../../hooks'

export function useAppointmentTypeTranslation(appointmentParams: {
  appointmentType: string
  shopId: string | undefined
  fitterName: string | undefined
  cabinName: string | undefined
  hideProviderName?: boolean
}) {
  const { t } = useTranslation()

  const { appointmentType, shopId, fitterName, cabinName, hideProviderName } = appointmentParams

  const showFitterName = !!fitterName
  const showCabinName = !!cabinName

  const fetchShop = !showFitterName && showCabinName && !!shopId

  const { data: shops } = useShops({ id: shopId as string }, { enabled: fetchShop })
  const shop = shops?.[0]

  const shopName = shop?.name

  const params = useMemo(() => {
    return { appointmentType, shopId, fitterName, cabinName, shopName }
  }, [appointmentType, shopId, fitterName, cabinName, shopName])

  const getAppointmentTypeTranslation = useCallback(() => {
    if (hideProviderName) {
      return t('schedule.appointmentTypeWithTopProvider', { appointmentType })
    }

    if (showFitterName && showCabinName) {
      return t('schedule.appointmentTypeWithBoth', params)
    }

    if (showFitterName) {
      return t('schedule.appointmentTypeWithFitter', params)
    }

    if (showCabinName) {
      if (params.shopName) {
        return t('schedule.appointmentTypeWithCabin', params)
      }
      return t('schedule.appointmentTypeWithCabinNoShop', params)
    }

    return t('schedule.appointmentType', params)
  }, [appointmentType, hideProviderName, params, showFitterName, showCabinName, t])

  return { getAppointmentTypeTranslation }
}
